import React, { useRef, useState, useEffect } from "react";
import {
    Box,
    Typography,
    TextField,
    Grid,
    Stack,
    IconButton,
    Button,
    Skeleton,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import ApartmentIcon from "@mui/icons-material/Apartment";
// import UploadRoundedIcon from "@mui/icons-material/UploadRounded";
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import RocketLaunchRoundedIcon from "@mui/icons-material/RocketLaunchRounded";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import GBARegistrationSuccess from "./GBARegistrationSuccess";
import OceshaLogo from "../../assets/ocesha_images/ocesha_logo.png";
import axios from "axios";
import { toast } from "react-toastify";
import { useGetUserDetailsMutation } from "../../redux/api/authApi";
import { getCookie } from "utils/storageUtils";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";

const GBA_Registration = () => {
    const fileInputRef = useRef<HTMLInputElement>(null);

    const [organizationName, setOrganizationName] = useState("");

    const [website, setWebsite] = useState("");

    const [description, setDescription] = useState("");

    const [welcomeMessage, setWelcomeMessage] = useState("");

    const [contactName, setContactName] = useState("");

    const [contactEmail, setContactEmail] = useState("");

    const [logoPreview, setLogoPreview] = useState<any>();

    const [isNext, setIsNext] = useState<boolean>(false);
    const [logoFile, setLogoFile] = useState<File | null>(null);
    const [errors, setErrors] = useState({
        organizationName: "",
        description: "",
        contactName: "",
        contactEmail: "",
        logo: "",
    });
    const [isExistingPartner, setIsExistingPartner] = useState(false);
    const [loading, setLoading] = useState(true);
    const [userDets, setUserDets] = useState<any>();
    const [getUserDetailsMutation] = useGetUserDetailsMutation();
    const useremail = localStorage.getItem("user_email") || "";
    const [deletingLogo, setDeletingLogo] = useState(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

    const handleLogoUpload = (
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        if (!e.target.files?.length) return;

        const file = e.target.files[0];

        setLogoFile(file);
        setLogoPreview(URL.createObjectURL(file));

        setErrors((prev) => ({
            ...prev,
            logo: "",
        }));
    };

    const handleDeleteLogo = async () => {
        const partnerName =
            userDets?.partner || localStorage.getItem("partner_name");

        if (!partnerName) {
            toast.error("Partner name not found");
            return;
        }

        try {
            setDeletingLogo(true);

            const response = await axios.post(
                `${apiUrl}/api/admin/delete_partner_logo`,
                {},
                {
                    params: {
                        partner_name: partnerName,
                    },
                }
            );

            if (response.data?.status === "updated") {
                setLogoPreview("");
                setLogoFile(null);

                if (fileInputRef.current) {
                    fileInputRef.current.value = "";
                }

                toast.success("Logo deleted successfully");

                window.dispatchEvent(
                    new CustomEvent("partner-logo-updated", {
                        detail: {
                            logo: "",
                        },
                    })
                );
                /* setTimeout(() => {
                    window.location.reload();
                }, 1000); */
            } else {
                toast.error("Unable to delete logo");
            }
        } catch (err) {
            console.error(err);
            toast.error("Failed to delete logo");
        } finally {
            setDeletingLogo(false);
            setDeleteDialogOpen(false);
        }
    };

    const fetchData = async () => {
        try {
            const response = await getUserDetailsMutation({
                email: useremail || getCookie("user_email") || "",
                filter: "",
                start_date: "",
                end_date: "",
            });

            if ("data" in response) {
                setUserDets(response.data.data);
                // console.log('user details =>', response.data.data);
                // console.log(response.data.data);
            }
        } catch (error) { }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const getPartnerDetails = async () => {
        try {
            setLoading(true);

            const response = await axios.get(
                `${apiUrl}/api/users/partners/details`,
                {
                    params: {
                        partner_name: userDets?.partner || localStorage.getItem('partner_name')/* "GPA" */,
                    },
                }
            );

            console.log('response of getting partner details =>', response);

            if (
                response.data?.status === "success" &&
                response.data?.data
            ) {
                const data = response.data.data;

                setOrganizationName(data.organization_name || "");
                setWebsite(data.website_url || "");
                setDescription(data.short_description || "");
                setWelcomeMessage(data.welcome_message || "");
                setContactName(data.primary_contact_name || "");
                setContactEmail(data.contact_email || "");

                if (data.logo_url) {
                    setLogoPreview(data.logo_url);
                }

                setIsExistingPartner(true);
            }
        } catch (err) {
            console.log("Partner details not found", err);

            setIsExistingPartner(false);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (userDets?.partner || localStorage.getItem('partner_name')) {
            getPartnerDetails();
        }
    }, []);

    const validateForm = () => {
        const newErrors = {
            organizationName: "",
            description: "",
            contactName: "",
            contactEmail: "",
            logo: "",
        };

        let valid = true;

        if (!organizationName.trim()) {
            newErrors.organizationName = "Organization name is required";
            valid = false;
        }

        if (!description.trim()) {
            newErrors.description = "Short description is required";
            valid = false;
        }

        if (!contactName.trim()) {
            newErrors.contactName = "Primary contact name is required";
            valid = false;
        }

        if (!contactEmail.trim()) {
            newErrors.contactEmail = "Contact email is required";
            valid = false;
        } else if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(contactEmail)
        ) {
            newErrors.contactEmail = "Invalid email address";
            valid = false;
        }

        /* if (!logoFile && !logoPreview) {
            newErrors.logo = "Organization logo is required";
            valid = false;
        } */

        setErrors(newErrors);

        return valid;
    };

    const apiUrl = process.env.REACT_APP_SERVER_ENDPOINT || "";

    const submitRegistration = async () => {
        if (!validateForm()) return;

        try {
            const formData = new FormData();

            formData.append(
                "organization_name",
                organizationName
            );

            formData.append(
                "website_url",
                website
            );

            formData.append(
                "short_description",
                description
            );

            formData.append(
                "welcome_message",
                welcomeMessage
            );

            formData.append(
                "primary_contact_name",
                contactName
            );

            formData.append(
                "contact_email",
                contactEmail
            );

            if (logoFile) {
                formData.append("logo", logoFile);
            }

            const response = await axios.post(
                `${apiUrl}/api/users/partners/update`,
                formData,
                {
                    params: {
                        partner_name: userDets?.partner || localStorage.getItem('partner_name'),
                    },
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            // console.log('GPA registration response =>', response);

            if (response.data.status === 'success') {
                setIsNext(true);

                window.dispatchEvent(
                    new CustomEvent("partner-logo-updated", {
                        detail: {
                            logo: response.data.data.logo_url || "",
                        },
                    })
                );
                /* if (logoFile) {
                    setTimeout(() => {
                        window.location.reload();
                    }, 2000); 
                } */
            } else {
                toast.error('Something went wrong, please try again later!');
            }
        } catch (error) {
            console.error(error);
        }
    };

    if (loading) {
        return (
            <Box
                sx={{
                    minHeight: "100vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <Box
                    sx={{
                        width: "100%",
                        maxWidth: 980,
                        borderRadius: "24px",
                        background: "#121826",
                        border: "1px solid rgba(255,255,255,.08)",
                        p: 5,
                    }}
                >
                    <Skeleton
                        variant="text"
                        width={320}
                        height={45}
                        sx={{ bgcolor: "grey.800" }}
                    />

                    <Skeleton
                        variant="text"
                        width={450}
                        height={25}
                        sx={{ bgcolor: "grey.800", mb: 4 }}
                    />

                    {[1, 2, 3, 4, 5, 6].map((item) => (
                        <Box key={item} mb={3}>
                            <Skeleton
                                variant="text"
                                width={180}
                                height={25}
                                sx={{ bgcolor: "grey.800", mb: 1 }}
                            />
                            <Skeleton
                                variant="rounded"
                                height={58}
                                sx={{ bgcolor: "grey.800" }}
                            />
                        </Box>
                    ))}

                    <Skeleton
                        variant="rounded"
                        height={60}
                        sx={{ bgcolor: "grey.800", mt: 3 }}
                    />
                </Box>
            </Box>
        );
    }

    return (
        <>
            {isNext === true ? (
                <GBARegistrationSuccess partnerName={userDets?.partner} logoPrev={logoPreview} />
            ) : (
                <Box
                    sx={{
                        minHeight: "100vh",
                        /* background:
                            "radial-gradient(circle at top,#1C2340 0%,#111827 45%,#090D18 100%)", */
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        /* py: 6,
                        px: 2, */
                    }}
                >
                    <Box
                        sx={{
                            width: "100%",
                            maxWidth: 980,
                            borderRadius: "24px",
                            background: "#121826",
                            border: "1px solid rgba(255,255,255,.08)",
                            boxShadow: "0 25px 60px rgba(0,0,0,.55)",
                            p: 5,
                        }}
                    >
                        {/* Header */}

                        <Stack
                            direction="row"
                            justifyContent="space-between"
                            alignItems="flex-start"
                            mb={5}
                        >
                            <Stack direction="row" spacing={2}>
                                <Box
                                    sx={{
                                        width: 56,
                                        height: 56,
                                        borderRadius: "50%",
                                        /* background:
                                            "linear-gradient(135deg,#635BFF,#7D48FF)", */
                                        background:
                                            "radial-gradient(circle at 30% 30%, #3B377D 0%, #2D2A63 65%, #252155 100%)",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <ApartmentIcon
                                        sx={{
                                            color: "#fff",
                                            fontSize: 28,
                                        }}
                                    />
                                </Box>

                                <Box>
                                    <Typography
                                        sx={{
                                            color: "#fff",
                                            fontWeight: 700,
                                            fontSize: 30,
                                        }}
                                    >
                                        Member Benefit Setup
                                    </Typography>

                                    <Typography
                                        sx={{
                                            color: "#9DA8BE",
                                            mt: .5,
                                            fontSize: 15,
                                        }}
                                    >
                                        Set up your association to provide a branded
                                        experience for your members.
                                    </Typography>
                                </Box>
                            </Stack>

                            {/* <IconButton
                                sx={{
                                    color: "#A7B1C6",
                                    border: "1px solid rgba(255,255,255,.08)",
                                    bgcolor: "#1B2234",
                                }}
                            >
                                <CloseIcon />
                            </IconButton> */}
                        </Stack>

                        {/* Organization Name */}

                        <Box mb={3}>
                            <Typography
                                sx={{
                                    color: "#fff",
                                    mb: 1,
                                    fontWeight: 600,
                                }}
                            >
                                Organization Name
                                <Box
                                    component="span"
                                    sx={{
                                        color: "#8B5CF6",
                                        ml: 0.5
                                    }}
                                >
                                    *
                                </Box>
                            </Typography>
                            <Typography
                                sx={{
                                    color: "#7D879C",
                                    fontSize: 13,
                                    mb: 2,
                                }}
                            >
                                The full name of your association
                            </Typography>
                            <TextField
                                fullWidth
                                value={organizationName}
                                onChange={(e) =>
                                    setOrganizationName(e.target.value)
                                }
                                InputProps={{
                                    sx: {
                                        height: 58,
                                        borderRadius: "12px",
                                        background: "#1B2334",
                                        color: '#fff !important',

                                        "& .MuiInputBase-input": {
                                            color: "#fff !important",
                                        },

                                        "& fieldset": {
                                            borderColor: "#364056",
                                        },

                                        "&:hover fieldset": {
                                            borderColor: "#6C63FF",
                                        },

                                        "&.Mui-focused fieldset": {
                                            borderColor: "#7C4DFF",
                                        },
                                    },
                                }}
                                error={!!errors.organizationName}
                                helperText={errors.organizationName}
                            />
                        </Box>

                        {/* Website */}

                        <Box mb={3}>
                            <Typography
                                sx={{
                                    color: "#fff",
                                    mb: 1,
                                    fontWeight: 600,
                                }}
                            >
                                Organization Website
                            </Typography>
                            <Typography
                                sx={{
                                    color: "#7D879C",
                                    mb: 2,
                                    fontSize: 13,
                                }}
                            >
                                Your official website (optional)
                            </Typography>
                            <TextField
                                fullWidth
                                value={website}
                                onChange={(e) =>
                                    setWebsite(e.target.value)
                                }
                                InputProps={{
                                    sx: {
                                        height: 58,
                                        borderRadius: "12px",
                                        background: "#1B2334",
                                        color: '#fff !important',

                                        "& .MuiInputBase-input": {
                                            color: "#fff !important",
                                        },
                                        "& fieldset": {
                                            borderColor: "#364056",
                                        },

                                        "&:hover fieldset": {
                                            borderColor: "#6C63FF",
                                        },

                                        "&.Mui-focused fieldset": {
                                            borderColor: "#7C4DFF",
                                        },
                                    },
                                }}
                            />
                        </Box>

                        {/* Organization Logo */}

                        <Box mb={3}>
                            <Typography
                                sx={{
                                    color: "#fff",
                                    fontWeight: 600,
                                    mb: 1,
                                }}
                            >
                                Organization Logo
                                {/* <Box
                                    component="span"
                                    sx={{
                                        color: "#8B5CF6",
                                        ml: 0.5
                                    }}
                                >
                                    *
                                </Box> */}
                            </Typography>

                            <Typography
                                sx={{
                                    color: "#7D879C",
                                    fontSize: 13,
                                    mb: 2,
                                }}
                            >
                                Upload your association logo (PNG or SVG)
                            </Typography>

                            <Grid container spacing={3}>
                                {/* Upload Box */}

                                <Grid item xs={12} md={6}>
                                    <Box
                                        onClick={() => fileInputRef.current?.click()}
                                        sx={{
                                            height: 90,
                                            border: "2px dashed #46506C",
                                            borderRadius: "16px",
                                            background: "#171E2F",
                                            cursor: "pointer",
                                            transition: ".25s",
                                            p: 2,

                                            display: "flex",
                                            justifyContent: "left",
                                            alignItems: "center",

                                            "&:hover": {
                                                borderColor: "#7666FF",
                                                background: "#1B2335",
                                            },
                                        }}
                                    >
                                        <Stack
                                            direction="row"
                                            spacing={2}
                                            alignItems="center"
                                            justifyContent="left"
                                        >
                                            <Box
                                                sx={{
                                                    width: 40,
                                                    height: 40,
                                                    borderRadius: "50%",
                                                    // background: "linear-gradient(135deg,#635BFF,#7A49FF)",
                                                    background:
                                                        "radial-gradient(circle at 30% 30%, #3B377D 0%, #2D2A63 65%, #252155 100%)",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    flexShrink: 0,
                                                }}
                                            >
                                                <FileUploadOutlinedIcon
                                                    sx={{
                                                        color: "#fff",
                                                        fontSize: 25,
                                                    }}
                                                />
                                            </Box>

                                            <Box>
                                                <Typography
                                                    sx={{
                                                        color: "#fff",
                                                        fontWeight: 600,
                                                    }}
                                                >
                                                    Click to upload your logo
                                                </Typography>

                                                <Typography
                                                    sx={{
                                                        color: "#95A0B8",
                                                        fontSize: 13,
                                                    }}
                                                >
                                                    PNG or SVG, max 2MB
                                                </Typography>
                                            </Box>
                                        </Stack>

                                        <input
                                            hidden
                                            type="file"
                                            accept=".png,.svg,.jpg,.jpeg"
                                            ref={fileInputRef}
                                            onChange={handleLogoUpload}
                                        />
                                    </Box>
                                </Grid>

                                {/* Preview */}

                                {/* <Grid
                            item
                            xs={12}
                            md={6}
                            sx={{
                                display: "flex",
                                alignItems: "center",     // Vertical center
                                justifyContent: "center", // Horizontal center
                            }}
                        >
                            <Box
                                sx={{
                                    width: "100%",
                                    height: 90, // Same height as upload box
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderRadius: "16px",
                                    background: "#fff", // Optional, like the reference UI
                                    overflow: "hidden",
                                }}
                            >
                                <img
                                    src={logoPreview}
                                    alt="Logo"
                                    style={{
                                        maxWidth: "85%",
                                        maxHeight: "85%",
                                        objectFit: "contain",
                                    }}
                                />
                            </Box>
                        </Grid> */}
                                <Grid
                                    item
                                    xs={12}
                                    md={6}
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        height: 100,
                                        pl: 2,
                                    }}
                                >
                                    {/*  {logoPreview && (
                                        <img
                                            src={logoPreview}
                                            alt="Logo"
                                            style={{
                                                maxWidth: "100%",
                                                maxHeight: "100px",
                                                objectFit: "contain",
                                            }}
                                        />
                                    )} */}
                                    {logoPreview && (
                                        <Box
                                            sx={{
                                                position: "relative",
                                                display: "inline-flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                            }}
                                        >
                                            <img
                                                src={logoPreview}
                                                alt="Logo"
                                                style={{
                                                    maxWidth: "100%",
                                                    maxHeight: "100px",
                                                    objectFit: "contain",
                                                }}
                                            />

                                            <IconButton
                                                size="small"
                                                // onClick={handleDeleteLogo}
                                                onClick={() => setDeleteDialogOpen(true)}
                                                disabled={deletingLogo}
                                                sx={{
                                                    position: "absolute",
                                                    top: -10,
                                                    right: -10,
                                                    width: 32,
                                                    height: 32,
                                                    bgcolor: "#E53935",
                                                    color: "#fff",
                                                    "&:hover": {
                                                        bgcolor: "#C62828",
                                                    },
                                                    boxShadow: "0 4px 10px rgba(0,0,0,.35)",
                                                }}
                                            >
                                                <DeleteOutlineRoundedIcon fontSize="small" />
                                            </IconButton>
                                        </Box>
                                    )}
                                </Grid>
                            </Grid>
                        </Box>

                        {/* Short Description */}

                        <Box mb={3}>
                            <Typography
                                sx={{
                                    color: "#fff",
                                    fontWeight: 600,
                                    mb: 1,
                                }}
                            >
                                Short Description
                                <Box
                                    component="span"
                                    sx={{
                                        color: "#8B5CF6",
                                        ml: 0.5
                                    }}
                                >
                                    *
                                </Box>
                            </Typography>

                            <Typography
                                sx={{
                                    color: "#7D879C",
                                    fontSize: 13,
                                    mb: 1.5,
                                }}
                            >
                                A brief description of your association
                                (max 300 characters)
                            </Typography>

                            <TextField
                                fullWidth
                                multiline
                                rows={4}
                                value={description}
                                onChange={(e) =>
                                    setDescription(e.target.value)
                                }
                                InputProps={{
                                    sx: {
                                        color: "#fff",
                                        borderRadius: "14px",
                                        background: "#1B2334",
                                        alignItems: "flex-start",

                                        "& fieldset": {
                                            borderColor: "#364056",
                                        },

                                        "&:hover fieldset": {
                                            borderColor: "#6D62FF",
                                        },

                                        "&.Mui-focused fieldset": {
                                            borderColor: "#7B4DFF",
                                        },
                                    },
                                }}
                                error={!!errors.description}
                                helperText={errors.description}
                            />

                            <Typography
                                sx={{
                                    mt: 1,
                                    color: "#8F99AE",
                                    textAlign: "right",
                                    fontSize: 13,
                                }}
                            >
                                {description.length}/300
                            </Typography>
                        </Box>

                        {/* Welcome Message */}

                        <Box mb={3}>
                            <Typography
                                sx={{
                                    color: "#fff",
                                    fontWeight: 600,
                                    mb: 1,
                                }}
                            >
                                Welcome Message
                                <Typography
                                    component="span"
                                    sx={{
                                        color: "#95A1B8",
                                        ml: .5,
                                        fontWeight: 400,
                                    }}
                                >
                                    (Optional)
                                </Typography>
                            </Typography>

                            <Typography
                                sx={{
                                    color: "#7D879C",
                                    fontSize: 13,
                                    mb: 1.5,
                                }}
                            >
                                A welcome message for your members
                                (max 500 characters)
                            </Typography>

                            <TextField
                                fullWidth
                                multiline
                                rows={4}
                                value={welcomeMessage}
                                onChange={(e) =>
                                    setWelcomeMessage(e.target.value)
                                }
                                InputProps={{
                                    sx: {
                                        color: "#fff",
                                        borderRadius: "14px",
                                        background: "#1B2334",
                                        alignItems: "flex-start",

                                        "& fieldset": {
                                            borderColor: "#364056",
                                        },

                                        "&:hover fieldset": {
                                            borderColor: "#6D62FF",
                                        },

                                        "&.Mui-focused fieldset": {
                                            borderColor: "#7B4DFF",
                                        },
                                    },
                                }}
                            />

                            <Typography
                                sx={{
                                    mt: 1,
                                    color: "#8F99AE",
                                    textAlign: "right",
                                    fontSize: 13,
                                }}
                            >
                                {welcomeMessage.length}/500
                            </Typography>
                        </Box>

                        {/* Contact Information */}

                        <Grid container spacing={3} mb={3}>
                            <Grid item xs={12} md={6}>
                                <Typography
                                    sx={{
                                        color: "#fff",
                                        fontWeight: 600,
                                        mb: 1,
                                    }}
                                >
                                    Primary Contact Name
                                    <Box
                                        component="span"
                                        sx={{
                                            color: "#8B5CF6",
                                            ml: 0.5
                                        }}
                                    >
                                        *
                                    </Box>
                                </Typography>

                                <Typography
                                    sx={{
                                        color: "#7D879C",
                                        fontSize: 13,
                                        mb: 1.5,
                                    }}
                                >
                                    Name of the primary association contact
                                </Typography>

                                <TextField
                                    fullWidth
                                    value={contactName}
                                    onChange={(e) => setContactName(e.target.value)}
                                    InputProps={{
                                        sx: {
                                            height: 58,
                                            borderRadius: "12px",
                                            background: "#1B2334",

                                            color: '#fff !important',

                                            "& .MuiInputBase-input": {
                                                color: "#fff !important",
                                            },
                                            "& fieldset": {
                                                borderColor: "#364056",
                                            },

                                            "&:hover fieldset": {
                                                borderColor: "#6C63FF",
                                            },

                                            "&.Mui-focused fieldset": {
                                                borderColor: "#7C4DFF",
                                            },
                                        },
                                    }}
                                    error={!!errors.contactName}
                                    helperText={errors.contactName}
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <Typography
                                    sx={{
                                        color: "#fff",
                                        fontWeight: 600,
                                        mb: 1,
                                    }}
                                >
                                    Contact Email
                                    <Box
                                        component="span"
                                        sx={{
                                            color: "#8B5CF6",
                                            ml: 0.5
                                        }}
                                    >
                                        *
                                    </Box>
                                </Typography>

                                <Typography
                                    sx={{
                                        color: "#7D879C",
                                        fontSize: 13,
                                        mb: 1.5,
                                    }}
                                >
                                    Email address for program administration
                                </Typography>

                                <TextField
                                    fullWidth
                                    value={contactEmail}
                                    onChange={(e) => setContactEmail(e.target.value)}
                                    InputProps={{
                                        sx: {
                                            height: 58,
                                            borderRadius: "12px",
                                            background: "#1B2334",
                                            color: '#fff !important',

                                            "& .MuiInputBase-input": {
                                                color: "#fff !important",
                                            },
                                            "& fieldset": {
                                                borderColor: "#364056",
                                            },

                                            "&:hover fieldset": {
                                                borderColor: "#6C63FF",
                                            },

                                            "&.Mui-focused fieldset": {
                                                borderColor: "#7C4DFF",
                                            },
                                        },
                                    }}
                                    error={!!errors.contactEmail}
                                    helperText={errors.contactEmail}
                                />
                            </Grid>
                        </Grid>

                        {/* Submit Button */}

                        <Button
                            fullWidth
                            variant="contained"
                            startIcon={<RocketLaunchRoundedIcon />}
                            sx={{
                                height: 60,
                                borderRadius: "14px",
                                textTransform: "none",
                                fontWeight: 700,
                                fontSize: "17px",
                                color: '#fff !important',

                                "& .MuiInputBase-input": {
                                    color: "#fff !important",
                                },

                                background:
                                    "linear-gradient(90deg,#5A54FF 0%, #7C4DFF 100%)",

                                // boxShadow: "0px 10px 30px rgba(90,84,255,.35)",

                                "&:hover": {
                                    background:
                                        "linear-gradient(90deg,#5A54FF 0%, #7C4DFF 100%)",
                                },
                            }}
                            onClick={submitRegistration}
                            disabled={loading}
                        >
                            {/* Create Member Benefit Program */}
                            {isExistingPartner
                                ? "Update Members Benefit Details"
                                : "Create Members Benefit Program"}
                        </Button>

                        {/* Footer */}

                        <Stack
                            direction="row"
                            spacing={1}
                            justifyContent="center"
                            alignItems="center"
                            mt={3}
                        >
                            <LockOutlinedIcon
                                sx={{
                                    color: "#8B96AD",
                                    fontSize: 18,
                                }}
                            />

                            <Typography
                                sx={{
                                    color: "#8B96AD",
                                    fontSize: 13,
                                }}
                            >
                                Your information is secure and will never be shared.
                            </Typography>
                        </Stack>
                    </Box>
                </Box>
            )}

            {/* Modals */}
            <Dialog
                open={deleteDialogOpen}
                onClose={() => setDeleteDialogOpen(false)}
                maxWidth="xs"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: "18px",
                        background: "#121826",
                        color: "#fff",
                        p: 1,
                    },
                }}
            >
                <DialogTitle
                    sx={{
                        textAlign: "center",
                        fontWeight: 700,
                        pb: 1,
                    }}
                >
                    Delete Logo?
                </DialogTitle>

                <DialogContent>
                    <Typography
                        sx={{
                            color: "#9DA8BE",
                            textAlign: "center",
                        }}
                    >
                        Are you sure you want to remove your organization logo? You can upload a new logo anytime later.
                    </Typography>
                </DialogContent>

                <DialogActions
                    sx={{
                        justifyContent: "center",
                        gap: 2,
                        p: 3,
                    }}
                >
                    <Button
                        variant="outlined"
                        onClick={() => setDeleteDialogOpen(false)}
                        sx={{
                            borderRadius: "10px",
                            textTransform: "none",
                            color: "#fff",
                            borderColor: "#46506C",
                            px: 3,
                        }}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        color="error"
                        onClick={handleDeleteLogo}
                        disabled={deletingLogo}
                        sx={{
                            borderRadius: "10px",
                            textTransform: "none",
                            px: 3,
                        }}
                    >
                        {deletingLogo ? "Deleting..." : "Delete"}
                    </Button>
                </DialogActions>
            </Dialog>
            {/* end modals */}
        </>
    );
};

export default GBA_Registration;